import { createStyles } from '../../../../../../styles/helpers'

export default createStyles({
  remainingBudgetError: {
    fontSize: 14,
    paddingLeft: 0
  }
})
